/**
* In Parent function is used to list the Parent details and its functions declare this file
**/
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import ApiService from '../../services/ApiService';
import Pagination from '../components/Pagination';
import AnalyticsModal from '../modals/AnalyticsModal';
import { goBack, convertS3privateToPublic } from '../../services/UtilsService';
import { toast } from 'react-toastify';
// import constantVariables from '../../dataset/constantVariables.json';
import DeleteModal from '../modals/DeleteModal';
import { useTranslation } from 'react-i18next';

function Parent() {
	//Intial state declaration
	const [data, setData] = useState({});
	const [modal, setModal] = useState({});
	const [request, setRequest] = useState({ page: 0, limit: 10 });
	const role = Number(localStorage.getItem('role'));
	const { t } = useTranslation();

	//components initialize function and api handling
	useEffect(() => {
		(async () => {
			var response = await ApiService.parentsList(request);
			setData(response.data);
		})();
	}, [request]);

	//To close modal
	const handleClose = () => setModal({});

	/** 
	* To handle Sort functions
	* @e - we get the event details from the change action
	**/
	const handleSortChange = (e) => {
		e.preventDefault();
		const { name, value } = e.target;
		setRequest({ ...request, [name]: value });
	};

	/** 
	* To handle pagination event
	* @data - we pass the page number
	**/
	const handlePaginate = (data) => {
		setRequest({ ...request, page: data });
	};

	/** 
	* To handle search functions
	* @e - we get the event details from the change action
	**/
	const handleChange = async (e) => {
		e.preventDefault();
		const { name, value } = e.target;
		setRequest({ ...request, [name]: value, page: 0 });
	};

	/**
	* To delete parent 
	* @event - we  pass the value and id 
	* id - pass the particular parent id
	* value - pass the boolean value
	**/
	const handleDelete = async (event) => {
		const { value, id } = event;
		if (value) {
			await setModal({ ...modal, delete: !value })
			const response = await ApiService.deleteParent(id);
			if (response.status === 200) {
				toast.success(response?.data?.message);
				setModal({ ...modal, value: value, modal: 'success' })
				setRequest({ ...request });
			} else {
				toast.error(response?.data?.message);
			}
		}
	};

	return (
		<main id="main" className="main">
			{/*Import Analytics Model*/}
			{Object.keys(modal).length !== 0 && modal?.show && <AnalyticsModal data={modal} handleClose={handleClose} />}

			{/*Import DeleteModal*/}
			{Object.keys(modal).length !== 0 && modal?.delete && <DeleteModal data={modal} handleDelete={handleDelete} handleClose={handleClose} />}

			{/*Page Title Section*/}
			<div className="pagetitle clearfix">
				<div className="float-start">
					<h1>{t('sidebar.parents')}</h1>
					<nav>
						<ol className="breadcrumb">
							<li className="breadcrumb-item">
								<Link to={window.location.href.includes('hospital') ? "/hospital/admin/dashboard" : "/admin/dashboard"}>
									{t('sidebar.home')}
								</Link>
							</li>
							<li className="breadcrumb-item active">{t('sidebar.parents')}</li>
						</ol>

					</nav>
				</div>
				<div className="float-end mt-2 me-1">
					<span onClick={goBack} className="backIcon"><i className="iconly-Bold-ArrowLeftSquare"></i></span>
				</div>
			</div>
			{/*End Page Title Section*/}

			{/* Page Content Section */}
			<section className="pagesection">
				<div className="row my-3">
					{/*Search*/}
					<div className="col-xxl-6 col-lg-6 d-flex">
						<div className="input-group input-group-sm me-2 w-50">
							<input type="text" name="search"
								onChange={handleChange} className="form-control" placeholder={t('common.search')} />
							<button className={`btn ${role === 4 ? 'btn-tmAquaDgreen' : 'btn-tmBlue'}`} type="button"><i className="ri-search-line"></i></button>
						</div>
					</div>
					{/* End Search*/}

					<div className="col-xxl-6 col-lg-6">
						<Link to={window.location.href.includes('hospital') ? "/hospital/admin/add-parent" : "/admin/add-parent"} className={`btn btn-sm ${role === 4 ? 'btn-outline-tmAquaDgreen' : 'btn-outline-tmBlue'} float-end`}>
							<i className="iconly-Bold-Plus align-middle me-1"></i> {t('common.addParent')}
						</Link>
						{/*Sort*/}
						<div className="dropdown float-end me-3">
							<a className={`btn btn-sm ${role === 4 ? 'btn-outline-tmAquaDgreen' : 'btn-outline-tmBlue'} dropdown-toggle`} href="javascript;" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false"> {t('common.sort')} </a>

							<ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
								<li>
									<button className={request.sort === 'added' ? `dropdown-item ${role === 4 ? 'admin-dropdown-item' : ''} active` : `dropdown-item ${role === 4 ? 'admin-dropdown-item' : ''}`} type="button" value="added" name="sort" onClick={handleSortChange} > {t('common.newlyAdded')} </button>
								</li>
								<li>
									<button className={request.sort === 'a-z' ? `dropdown-item ${role === 4 ? 'admin-dropdown-item' : ''} active` : `dropdown-item ${role === 4 ? 'admin-dropdown-item' : ''}`} type="button" value="a-z" name="sort" onClick={handleSortChange} > {t('common.alphabeticalOrder')} </button>
								</li>
							</ul>
						</div>
						{/*End Sort*/}
					</div>
				</div>

				{/*Table*/}
				<div className="row my-3">
					<div className="col-xxl-12">
						<div className={`table-responsive ${role === 4 ? 'admin-table-responsive' : ''}`}>
							<table className="table table-borderless theme-table">
								<thead>
									<tr>
										<th scope="col">{t('profile.parentName')}</th>
										<th scope="col">{t('table.analytics')}</th>
										<th scope="col" className="text-center">{t('profile.familyMember')}</th>
										<th scope="col">{t('table.contactNumber')}</th>
										<th scope="col">{t('profile.emailAddress')}</th>
										<th scope="col">{t('profile.location')}</th>
										<th scope="col" className="text-center">{t('profile.action')}</th>
									</tr>
								</thead>
								<tbody>
									{data && data.details && data.details.length !== 0 && data.details.map((item, i) => (
										<tr key={i}>
											<td >
												<Link to={window.location.href.includes('hospital')
													? `/hospital/admin/view-parent/${item.account}`
													: `/admin/parent/${item.account}`}>
													<div className="d-flex align-items-center ps-1">
														<div className="avtar-img">
															<span className="rounded-circle">
																{item?.photo === 'default.png' ? <img src="/assets/img/user-avatar.png" alt="UN" /> : <img src={convertS3privateToPublic(item?.photo)} alt="UN" />}
															</span>
														</div>
														<div className="ms-2">
															<h5 className="table-title text-capitalize">{item?.first_name + ' ' + item?.last_name}</h5>
														</div>
													</div>
												</Link>
											</td>
											<td className="text-center"><i onClick={() => setModal({ show: true, id: item?.account })} className="fa-solid fa-chart-column" ></i></td>
											<td className="text-center">{item.members}</td>
											<td style={{ whiteSpace: 'nowrap' }}>{item?.mobileNumber ?
												item?.countryCode + ' ' + item?.mobileNumber : '--'}</td>
											<td><a href={`mailto:${item?.email}`}>{item?.email}</a></td>
											<td className="text-capitalize">
												{item.city ? item.city + ',' : ''}
												{item.state ? item.state + ',' : ''}
												{item.zipcode ? item.zipcode : ''}
												{!(item.city || item.state || item.zipcode) ? '--' : ''}
											</td>

											<td className="text-center fw-normal">
												<Link
													to={window.location.href.includes('hospital')
														? `/hospital/admin/edit-parent/${item.account}`
														: `/admin/edit-parent/${item.account}`}
													className="text-warning d-inline"
												>
													<i className="iconly-Bold-Edit align-middle me-2"></i>
												</Link>
												<Link onClick={() => setModal({ delete: true, id: item?.account })} className="text-danger d-inline"><i className="iconly-Bold-Delete align-middle"></i></Link>
											</td>
										</tr>
									))}

									{data && data.details && !data.details.length && <tr>
										<td colSpan="7" className="text-center">{t('common.noRecord')}</td>
									</tr>}
								</tbody>
							</table>
						</div>
					</div>
				</div>
				{/*End Table*/}

				{/*Pagination*/}
				{data && data.length !== 0 && data.details && data.details.length !== 0 &&
					<div className="row my-3">
						<div className="col-xxl-12 d-flex justify-content-center">
							<Pagination page={request.page} handlePaginate={handlePaginate} total={data.counts} />
						</div>
					</div>}
				{/*End Pagination*/}
			</section>
			{/* End Page Content Section */}

		</main>
	);
}

export default Parent;
